module.exports = __webpack_public_path__ + "static/img/nine8.a335eb28.jpg";